const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class Partners extends DataServiceEndPoint {
  static key = "Partners"

  get = async ({ hospitalId }) => {
    const response = await this._httpService.get(`${this.url}/v1/partners/${hospitalId}?expand=true`, {
      headers: { Authorization: `bearer ${this.token}` },
    })
    return response
  }

  getAccessCode = async ({ partnerId, accessCode }) => {
    const query = accessCode
      ? `?code=${encodeURIComponent(String(accessCode))}`
      : "?partnerAccessCodeOnly=true"
    const response = await this._httpService.get(
      `${this.url}/v1/partners/${partnerId}/access-codes${query}`,
      { headers: { Authorization: `bearer ${this.token}` } }
    )
    return response
  }

  getTree = async ({ partnerId, active = true, _justChildren = false }) => {
    const statusQuery = active ? ", status: { _eq: Active }" : ""
    const matchField = _justChildren ? "parentAccount" : "id"
    const query = `
      query findChildren($id: uuid!) {
        clients(where: { ${matchField}: { _eq: $id }${statusQuery} }) {
          value: id
          title: clientName
          name
          showCollectDepartment
          ${active ? "" : "status"}
        }
      }
    `
    const data = { id: partnerId }
    const result = await this._hasuraService.query({ query, data })

    const output = []
    for (const client of result?.data?.clients || []) {
      const children = await this.getTree({ partnerId: client.value, active, _justChildren: true })
      output.push(children?.length ? { ...client, children } : client)
    }

    return output.sort((a, b) => a?.title?.localeCompare(b?.title))
  }
}

module.exports = Partners
